export default {
    congratulation: 'Congratulation',
    close: 'Close'
}
